/**
 * ModalHeader.jsx
 *
 * @Author: jruif
 * @Date: 2017/7/7 下午10:02
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
/**
 * @ignore
 * */
const ModalHeader = props => {
  const { children, prefixCls, className, component: Component, closeButton } = props;
  const classes = classNames(`${prefixCls}-header`, className, {
    [`${prefixCls}-header-has-title`]: children,
  });

  return (
    <div className={classes}>
      <Component className={`${prefixCls}-title`}>{children}</Component>
      {closeButton}
    </div>
  );
};

ModalHeader.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

ModalHeader.defaultProps = {
  component: 'h6',
  prefixCls: 'ne-modal',
};

export default ModalHeader;



// WEBPACK FOOTER //
// ./src/modal/ModalHeader.jsx